import UserProfileComponent from './UserProfileComponent';
import LinksForm from './Forms/LinksForm';

export default class ReviewStats extends UserProfileComponent {
    templateId() {
        return '#reviewStatsTemplate';
    }

    data() {
        return '/dashboard/profile/ajax/getReviewStats';
    }

    load(containerId) {
        var modalContainer = this.modalContainer();
        var loader = this.loader;
        $(containerId).on('load.rendered', function () {
            if (!$(this).html().trim()) {
                $(this).parent().remove();
            }
        });
        super.load(containerId);
    }
}
